import styled from 'styled-components';

import { LOADER_RESET } from '@ui-component-library/styles/components.reset';

export const S = {
  Wrapper: styled.div`
    ${LOADER_RESET}

    display: flex;
    align-items: center;
    justify-content: center;
    animation: rotating 1s linear infinite;

    @keyframes rotating {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `
};
